import {
  MONITOR_ORDER_COUNT_LOAD,
  MONITOR_ORDER_COUNT_SUCCESS,
  MONITOR_ORDER_COUNT_ERROR,
  MONITOR_BILL_COUNT_LOAD,
  MONITOR_BILL_COUNT_SUCCESS
} from "./actionTypes"

const initialState = {
  error: "",
  ordersCount: [],
  loading: false,
  billsCount: [],
}

const ordersCount = (state = initialState, action) => {
  switch (action.type) {
    case MONITOR_ORDER_COUNT_LOAD:
      state = {
        ...state,
        ordersCount: [],
        loading: true,
        error: "",
      }
      break
    case MONITOR_ORDER_COUNT_SUCCESS:
      state = {
        ...state,
        loading: false,
        error: "",
        ordersCount: action.payload,
      }
      break
    case MONITOR_ORDER_COUNT_ERROR:
      state = {
        ...state,
        error: action.payload,
        loading: false,
      }
      break
    case MONITOR_BILL_COUNT_LOAD:
      state = {
        ...state,
        billsCount: [],
        loading: true,
        error: "",
      }
      break
    case MONITOR_BILL_COUNT_SUCCESS:
      state = {
        ...state,
        loading: false,
        error: "",
        billsCount: action.payload,
      }
      break

  }
  return state
}

export default ordersCount
